import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-text",
  "use": "icon-text-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-text\"><path d=\"M128 192h768v64H128v-64zm0 256h768v64H128v-64zm0 256h768v64H128v-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol